import { NonNullish } from 'utils/nullish-check';
import { useReferralCode } from 'utils/omnivy';

const REFERRAL_CODE_STORAGE_KEY = 'snt:non_active_referral_code';

export default async () => {
  const checkUrlForCode = (url: URL) => {
    if (url.searchParams.has('referral')) {
      localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, NonNullish(url.searchParams.get('referral')));
    } else if (url.searchParams.has('return_url')) {
      const returnUrl = new URL(
        decodeURIComponent(NonNullish(url.searchParams.get('return_url'))),
        window.origin,
      );

      checkUrlForCode(returnUrl);
    }
  };

  const url = new URL(window.location.href, window.origin);
  checkUrlForCode(url);

  const code = localStorage.getItem(REFERRAL_CODE_STORAGE_KEY);

  if (code && theme.customer) {
    await useReferralCode(code, false);

    localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY);
    window.location.href = `${Shopify.routes.root}account?tab=tab-reward#referral`;
  }
};
